import * as React from "react";
import { gql, useMutation, ApolloError } from "@apollo/client";
import {
  SendForgotPasswordEmailAdminMutationMutation,
  SendForgotPasswordEmailAdminMutationMutationVariables
} from "../../../../schemaTypes";

const forgotPasswordAdminMutation = gql`
  mutation SendForgotPasswordEmailAdminMutation(
    $email: String!
  ) {
    sendForgotPasswordEmailAdmin(
      email: $email
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submit: (
        values: SendForgotPasswordEmailAdminMutationMutationVariables
      ) => Promise<SendForgotPasswordEmailAdminMutationMutation["sendForgotPasswordEmailAdmin"] | null>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

export const ForgotPasswordAdminController: React.FC<Props> = ({ children }) => {
  const [_forgotPasswordAdminMutation, { loading, error }] = useMutation<
    SendForgotPasswordEmailAdminMutationMutation,
    SendForgotPasswordEmailAdminMutationMutationVariables
  >(forgotPasswordAdminMutation);

  const submit = async (
    values: SendForgotPasswordEmailAdminMutationMutationVariables
  ) => {
    try {
      const result = await _forgotPasswordAdminMutation({ variables: values });
      return result.data?.sendForgotPasswordEmailAdmin ?? null;
    } catch {
      return null;
    }
  };

  return children({ submit, loading, error });
};